/*************************************************/
/* Vue                                           */
/*************************************************/
import { createApp, h } from 'vue';
import People from './vue/people.vue';

const peopleAppSelector = ".people-app";
const peopleAppElements = document.querySelectorAll(peopleAppSelector);
const peopleApps = [];
if (peopleAppElements) {
    peopleAppElements.forEach(element => {
        const defaultResultSet = element.dataset.defaultSet?.split(",").filter(x => x != "")?.map(x => parseInt(x));
        const filterFacets = element.dataset.filterFacets?.split(",").filter(x => x != "");

        const seedData = {
            defaultResultSet: defaultResultSet,
            filterFacets: filterFacets
        };

        peopleApps.push(createApp({
            data() { return seedData },
            render: () => h(People)
        }, seedData).mount('#' + element.id));
    });
}